import { useRef } from 'react'

export function useStickyResult(value) {
  const val = useRef()
  if (value !== undefined) val.current = value
  return val.current
}
